/* eslint-disable */
import { numeric } from './numeric.js'

/**
 * Format currency.
 *
 * Temp function
 *
 * @param  {number} value
 * @return {size}
 */
export const currency = (value = 0) => {
  const v = Number(value)

  if (!v) return v

  return numeric(value, { digits: 2 }).replace(/\D00(?=\D*$)/, '')
}
